import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AudioService {
  private audio: HTMLAudioElement;
  private loading = false;

  constructor() {
    this.audio = new Audio();
  }

  playSound(filePath: string): void {
    try {
      if (!this.loading) {
        this.loading = true;

        this.audio.src = filePath;
        this.audio.load();

        this.audio.play().finally(() => {
          this.loading = false;
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
}
